'use strict';

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'Во ред',
      clear: 'Исчисти'
    },
    datepicker: {
      now: 'Сега',
      today: 'TodaДенесy',
      cancel: 'Откажи',
      clear: 'Исчисти',
      confirm: 'Во ред',
      selectDate: 'Изберете датум',
      selectTime: 'Изберете време',
      startDate: 'Датум на почеток',
      startTime: 'Време на почеток',
      endDate: 'Датум на завршување',
      endTime: 'Крајно време',
      prevYear: 'Претходна година',
      nextYear: 'Следната година',
      prevMonth: 'Претходен месец',
      nextMonth: 'Следниот месец',
      year: '',
      month1: 'јануари',
      month2: 'февруари',
      month3: 'март',
      month4: 'април',
      month5: 'мај',
      month6: 'Јуни',
      month7: 'Јули',
      month8: 'август',
      month9: 'Септември',
      month10: 'Октомври',
      month11: 'ноември',
      month12: 'Декември',
      week: 'недела',
      weeks: {
        sun: 'Сонце',
        mon: 'Пон',
        tue: 'Вторник',
        wed: 'Сре',
        thu: 'Чет',
        fri: 'Пет',
        sat: 'Саб'
      },
      months: {
        jan: 'Јан',
        feb: 'февруари',
        mar: 'Март',
        apr: 'Апр',
        may: 'мај',
        jun: 'Јуни',
        jul: 'Јул',
        aug: 'Авг',
        sep: 'Септември',
        oct: 'Октомври',
        nov: 'Ноември',
        dec: 'Декември'
      }
    },
    select: {
      loading: 'Вчитување',
      noMatch: 'Нема соодветни податоци',
      noData: 'Нема податоци',
      placeholder: 'Изберете'
    },
    cascader: {
      noMatch: 'Нема соодветни податоци',
      loading: 'Вчитување',
      placeholder: 'Изберете',
      noData: 'Нема податоци'
    },
    pagination: {
      goto: 'Оди на',
      pagesize: '/страница',
      total: 'Вкупно {вкупно}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Порака',
      confirm: 'Во ред',
      cancel: 'Откажи',
      error: 'Недозволен внес'
    },
    upload: {
      deleteTip: 'притиснете избриши за да отстраните',
      delete: 'Избриши',
      preview: 'Преглед',
      continue: 'Продолжи'
    },
    table: {
      emptyText: 'Нема податоци',
      confirmFilter: 'Потврди',
      resetFilter: 'Ресетирај',
      clearFilter: 'Сите',
      sumText: 'Сума'
    },
    tree: {
      emptyText: 'Нема податоци'
    },
    transfer: {
      noMatch: 'Нема соодветни податоци',
      noData: 'Нема податоци',
      titles: ['Листа 1', 'Листа 2'], // to be translated
      filterPlaceholder: 'Внесете клучен збор', // to be translated
      noCheckedFormat: '{вкупно} ставки', // to be translated
      hasCheckedFormat: '{проверено}/{вкупно} проверено' // to be translated
    },
    image: {
      error: 'НЕУСПЕШНО'
    },
    pageHeader: {
      title: 'Назад' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Да',
      cancelButtonText: 'Не'
    },
    empty: {
      description: 'Нема податоци'
    }
  }
};
